import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/solid/image-fill.svg'
import _imports_1 from '@/assets/icons/solid/video-fill.svg'
import _imports_2 from '@/assets/icons/solid/list-bullet-fill.svg'


const _hoisted_1 = { class: "link" }
const _hoisted_2 = { class: "truncate inline-block space-x-1 text-sm w-full" }
const _hoisted_3 = { class: "grid grid-cols-3 gap-6" }
const _hoisted_4 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_5 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_0,
  alt: "picture icon"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_11 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_12 = {
  key: 1,
  controls: "",
  class: "object-cover w-96 h-75 rounded-md"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_1,
  alt: "video icon"
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]

import { // api
		getSceneOptionsRolesByRecordId
	} from '../../../../queries'

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	import { // vue
		inject,
		onMounted,
		ref, 
		computed
	} from 'vue'

	
	const __default__ = { name: 'SceneOptionsTabs' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		openToTab: {
			type: Number,
			default: 0
		},
		showDetails:{
			type: Function,
			default: () => {return}
		},
		option: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

	const _localesStore = localesStore()
	const userStore = _userStore()

	const {t} = useI18n()

	const childTabs = ref<{_tabs: []}>({_tabs: []})

	const isStaff = ref(userStore.getContactType === 'Staff')

	const groupedData = computed(() => {
		let headings = []

		if(standardRoles.value?.length) {
			headings.push(
				{subheading: 'Standard Roles'},
				...standardRoles.value
			)
		}

		if(musicianRoles.value?.length) {
			headings.push(
				{subheading: 'Musician Roles'},
				...musicianRoles.value
			)
		}
		
		return headings
	})

	const tabs = ref(
		isStaff.value ? [
			{ name: _localesStore.getLabel('293') + "/" + _localesStore.getLabel('294'), current: false },
			{ name: _localesStore.getLabel('179'), current: false }
		] :
		[
			{ name: _localesStore.getLabel('293') + "/" + _localesStore.getLabel('294'), current: false },
		])

	const props = __props

	const standardRoles = ref()
	const musicianRoles = ref()

	const loading = ref(false)
	const filesLoading = ref(false)
	const fetchS3File: any = inject('fetchS3File')
	const signedUrlPhoto = ref('')
	const signedUrlVideo = ref('')

	onMounted(async () => {
		tabs.value[props.openToTab].current = true

		try { // getting option details
			loading.value = true

			const recordId = props.option.recordId

			const scriptParams = JSON.stringify({
				language: _localesStore.getFmLanguage,
			})

			const params = `?script.prerequest=${encodeURI("Set Language")}&script.prerequest.param=${encodeURI(scriptParams)}`
			let res = await getSceneOptionsRolesByRecordId(recordId, params)
			const record = res.response.data[0]
			
			standardRoles.value = record.portalData.jobs_scenes_options__JOBS_SCENES_OPTIONS_ROLES__standardID
			musicianRoles.value = record.portalData.jobs_scenes_options__JOBS_SCENES_OPTIONS_ROLES__instrumentalID
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loading.value = false
		}

		try { // getting files from s3
			filesLoading.value = true
			const s3PhotoField = props.option?.['jobs_scenes__jobs_scenes_options__CONTACTS_SCENES_OPTIONS__contactsScenesOptionsID::s3JSONPicture'] || props.option?.['jobs_scenes__jobs_scenes_options__SERVICES_OPTIONS__servicesOptionsID::s3JSONPicture']
			const s3VideoField = props.option?.['jobs_scenes__jobs_scenes_options__CONTACTS_SCENES_OPTIONS__contactsScenesOptionsID::s3JSONVideo'] || props.option?.['jobs_scenes__jobs_scenes_options__SERVICES_OPTIONS__servicesOptionsID::s3JSONVideo']
			signedUrlPhoto.value = await fetchS3File(s3PhotoField)
			signedUrlVideo.value = await fetchS3File(s3VideoField)
		}
		catch(e) {
			console.error(e)
		}
		finally {
			filesLoading.value = false
		}
		
	})

	function hasInstructions(row: any) {
		return row?.['jobs_scenes_options__jobs_scenes_options_s_roles__INSTRUCTIONS_JOIN_JOBS__jobsScenesOptionsRolesID::_kp_instructions_join_jobs_id'] ||
			row?.['jobs_scenes_options__jobs_scenes_options_m_roles__INSTRUCTIONS_JOIN_JOBS__jobsScenesOptionsRolesID::_kp_instructions_join_jobs_id']
	}


return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_tw_tabs_underline = _resolveComponent("tw-tabs-underline")!
  const _component_data_display = _resolveComponent("data-display")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.showDetails(null, 'sceneDetails', 3, null))),
        class: "flex justify-start items-center cursor-pointer"
      }, [
        _createVNode(_component_ArrowLeftIcon, { class: "w-5 h-5" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.returnToOptions")), 1)
        ])
      ])
    ]),
    _createVNode(_component_tw_tabs_underline, {
      class: "mb-6",
      ref_key: "childTabs",
      ref: childTabs,
      tabs: tabs.value
    }, null, 8, ["tabs"]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_data_display, {
            label: _unref(_localesStore).getLabel('293')
          }, {
            custom: _withCtx(() => [
              (filesLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : (signedUrlPhoto.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "object-cover w-96 h-75 rounded-md",
                      src: signedUrlPhoto.value
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_data_display, {
            label: _unref(_localesStore).getLabel('294')
          }, {
            custom: _withCtx(() => [
              (filesLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                : (signedUrlVideo.value)
                  ? (_openBlock(), _createElementBlock("video", _hoisted_12, [
                      _createElementVNode("source", {
                        type: "video/mp4",
                        src: signedUrlVideo.value
                      }, null, 8, _hoisted_13)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[0]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_tw_table, {
        loading: loading.value,
        placeholder: _unref(t)('placeholders.noRoles'),
        data: groupedData.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('149'),
            prop: "jobs_scenes_options__jobs_scenes_options_roles__ROLES__roleID::name_display"
          }, null, 8, ["header"]),
          (isStaff.value)
            ? (_openBlock(), _createBlock(_component_tw_table_column, {
                key: 0,
                "class-name": "w-6 ",
                "header-class-name": "w-6",
                "align-text": "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("div", {
                    class: "h-6 w-6 cursor-pointer",
                    onClick: ($event: any) => (__props.showDetails(row, 'opRolesInstructionsList', null, __props.option))
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass([hasInstructions(row) ? 'linked-icon' : 'grayed-icon']),
                      src: _imports_2,
                      alt: "picture icon"
                    }, null, 2)
                  ], 8, _hoisted_17)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading", "placeholder", "data"])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[1]?.current]
    ])
  ]))
}
}

})